import { ref } from 'vue';
import { defineStore } from 'pinia';
import { dom } from 'quasar';

export const useLoaderStore = defineStore('loader', () => {
  const status = ref<boolean | null>(false);
  const key = ref(0);
  const show = () => {
    status.value = true;
    key.value += 1;
    dom.ready(() => {
      document.querySelector('#app')?.classList.add('overflow-hidden');
    });
  };

  const hide = () => {
    status.value = false;
    dom.ready(() => {
      document.querySelector('#app')?.classList.remove('overflow-hidden');
    });
  };

  return {
    status,
    key,
    show,
    hide,
  };
});
